<template>
  <FormDialogLayout
    :right="0"
    :width="30"
    className="company-form"
    :editable="isNewItem"
  >
    <template #header>
      <v-app-bar flat>
        <v-toolbar-title>
          {{
            isNewItem
              ? isAdmin
                ? formtitle + DIALOG_TITLE_ADDITIONS.ADD
                : formtitle + DIALOG_TITLE_ADDITIONS.SEARCH
              : formtitle + DIALOG_TITLE_ADDITIONS.EDIT
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-5"
          v-if="!editable"
          color="primary"
          @click="onEditable"
        >
          {{ DIALOG_BUTTON_NAMES.EDIT }}
        </v-btn>
        <v-btn icon @click="onClickBtnClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab v-for="(form, key) in tabs" :key="key">
              {{ form.title }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </template>
    <template #main="{ params }">
      <ValidationObserver ref="observer" v-slot="observer">
        <v-tabs-items v-model="tab">
          <!-- 追加 -->
          <v-tab-item v-if="!isAdmin && isNewItem">
            <AddCompany
              :item="formValues"
              :mainHeight="params.mainHeight"
              @formUpdate="formUpdate"
            />
          </v-tab-item>
          <!-- 新規登録 -->
          <v-tab-item>
            <FormBasicInfo
              :editable="editable"
              :item="formValues"
              :isNewItem="isNewItem"
              :mainHeight="params.mainHeight"
              @formUpdate="formUpdate"
            />
          </v-tab-item>
        </v-tabs-items>
        <ValidationCallback :observer="observer" @callback="updateValidate" />
      </ValidationObserver>

      <Popup width="500px" :dialog="popups.isShowConfirmDialog">
        <ConfirmDialog
          @close="onClickBtnCancelForm"
          @yes="closeForm"
          :isClose="true"
          :isCenter="false"
          title="フォームを閉じる確認"
          text="フォームを閉じますがよろしいですか？
        入力内容は保存されません。

        このページから移動してもよろしいですか？"
        />
      </Popup>
    </template>
    <template #footer>
      <v-toolbar>
        <v-spacer></v-spacer>
        <v-btn
          v-if="editable"
          class="mr-5"
          outlined
          color="primary"
          @click="popups.isShowConfirmDialog = true"
        >
          {{ DIALOG_BUTTON_NAMES.CANCEL }}
        </v-btn>
        <v-btn
          v-if="editable"
          class="ml-5"
          :disabled="!valid"
          color="primary"
          :key="keySubmit"
          @click.once="onSubmit"
        >
          {{
            tab == 0 && isNewItem
              ? DIALOG_BUTTON_NAMES.ADD
              : DIALOG_BUTTON_NAMES.SAVE
          }}
        </v-btn>
      </v-toolbar>
    </template>
  </FormDialogLayout>
</template>

<script>
import { Store } from "@/store/Store.js";
import { ValidationObserver } from "vee-validate";
import ValidationCallback from "@/components/forms/elements/ValidationCallback";
import { TITLE, FORMS, COMPANY_INITAL_ITEM } from "@/constants/COMPANY";
import {
  DIALOG_BUTTON_NAMES,
  DIALOG_TITLE_ADDITIONS,
  COMPANY_TYPE,
} from "@/constants/COMMON";

// Components
import Popup from "@/components/common/Popup";
import FormDialogLayout from "@/components/layout/FormDialogLayout";
import FormBasicInfo from "@/components/forms/company/FormBasicInfo";
import AddCompany from "@/components/forms/company/AddCompany";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";

//ストア
const STORE = "Company";

export default {
  components: {
    ValidationObserver,
    ValidationCallback,
    Popup,
    FormDialogLayout,
    AddCompany,
    ConfirmDialog,
    FormBasicInfo,
  },
  data: () => {
    return {
      TITLE,
      DIALOG_BUTTON_NAMES,
      DIALOG_TITLE_ADDITIONS,
      valid: false,
      tab: null,
      tabName: {},
      editable: false,
      popups: {
        isShowConfirmDialog: false,
      },
      isClickCloseBtn: false,
      formValues: { ...COMPANY_INITAL_ITEM },
      beforeUpdateItem: {},
      keySubmit: false,
    };
  },
  props: {
    isNewItem: Boolean,
  },
  mounted() {
    this.tabName = { ...FORMS };
    this.$watch(
      () => this.isNewItem,
      (flag) => {
        let formsArray = Object.entries(FORMS);
        if (flag) {
          this.editable = true;
          formsArray[1][1].title = "新規登録";
        } else {
          formsArray[1][1].title = "基本情報";
        }
        if (this.companyType == COMPANY_TYPE.ADMIN || !flag) {
          this.tabName = Object.fromEntries(formsArray.splice(1, 1));
        } else {
          this.tabName = Object.fromEntries(formsArray);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    this.$watch(
      () => [Store.getters[`${STORE}/getCompanyDetail`], this.editable],
      (data) => {
        if (!this.isNewItem) {
          this.formValues = { ...data[0] };
          this.beforeUpdateItem = { ...data[0] };
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
  },
  computed: {
    isAdmin() {
      return this.companyType === COMPANY_TYPE.ADMIN;
    },
    tabs() {
      return this.tabName;
    },
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    formtitle() {
      return this.isNewItem ? this.TITLE.NEW : this.TITLE.EDIT;
    },
  },
  methods: {
    formUpdate(params) {
      this.formValues = { ...this.formValues, ...params };
    },
    onEditable() {
      this.editable = true;
    },
    onDetail() {
      this.editable = false;
    },
    async onSubmit() {
      if (
        this.tab == 1 &&
        (this.isNewItem || this.beforeUpdateItem.corporate_number === null) &&
        this.formValues.is_required_corporate_number
      ) {
        let checkResult = await this.checkSubmit();
        if (!checkResult) {
          return;
        }
      }
      if (
        this.tab == 0 &&
        this.isNewItem &&
        Object.keys(this.tabName).length > 1
      ) {
        await this.addCompany();
      } else {
        await this.submit();
      }
    },
    async checkSubmit() {
      const apiParams = { ...this.formValues };
      const result = await Store.dispatch(
        `${STORE}/checkCompanyExits`,
        apiParams.corporate_number
      );
      if (result.hasError) {
        const { data } = result.response;
        Store.dispatch("Error/show", {
          status: data.status_code,
          message: data.message,
        });
        return false;
      }
      const entries = result.data.contents.entries;
      if (entries.isExits) {
        this.keySubmit = !this.keySubmit;
        Store.dispatch("Error/show", {
          status: 200,
          message: "既に登録済みの会社です。",
        });
        return false;
      }
      return true;
    },
    async addCompany(id) {
      const data = { ...this.formValues };
      let ids = id ? id : data.selected_item?.map((item) => item.id);
      let apiParams = {
        ids: ids,
        main_contractor_id: this.loginUser.company_id,
      };
      const result = await Store.dispatch(`${STORE}/add`, apiParams);
      if (result.hasError) {
        this.keySubmit = !this.keySubmit;
        return;
      } else {
        this.$emit("cancel");
        if (id == null) {
          Store.dispatch("Toast/show", {
            status: 200,
            message: "追加しました",
          });
        }
      }
    },
    async submit() {
      const apiParams = { ...this.formValues };
      const hasId = "id" in this.formValues;
      const result = await Store.dispatch(
        hasId ? `${STORE}/update` : `${STORE}/post`,
        apiParams
      );
      if (result.hasError) {
        this.keySubmit = !this.keySubmit;
        return;
      } else {
        if (this.isNewItem) {
          // 会社管理保存
          this.addCompany([result.data.contents.entries.id]);
          this.$emit("updateCompany", result.data.contents.entries.id);
          this.$emit("cancel");
        } else {
          this.getItems(apiParams.id);
          this.onDetail();
        }
        Store.dispatch("Toast/show", {
          status: 200,
          message: hasId ? "更新しました" : "登録しました",
        });
      }
    },
    updateValidate({ valid }) {
      this.valid = valid;
    },
    closeForm() {
      if (this.editable && !this.isNewItem && !this.isClickCloseBtn) {
        this.popups.isShowConfirmDialog = false;
        this.formValues = { ...this.beforeUpdateItem };
        this.editable = false;
      } else {
        this.$emit("cancel");
      }
    },
    onClickBtnClose() {
      if (!this.editable && !this.isNewItem) {
        this.$emit("cancel");
      } else {
        this.isClickCloseBtn = true;
        this.popups.isShowConfirmDialog = true;
      }
    },
    async getItems(id) {
      Store.dispatch(`${STORE}/getCompanyDetail`, id);
    },
    onClickBtnCancelForm() {
      this.popups.isShowConfirmDialog = false;
      this.isClickCloseBtn = false;
    },
  },
};
</script>
